export default class EventArchive {
	constructor() {
		this.parentClass = '.event-archive';
		this.tab = this.parentClass + '__menu li span';
	}

	init() {
		$(document).on('ready', function () {
			$(this.parentClass + '__menu li span').each(function () {
				const id = $(this).data('id');
				$(this).attr('id', id);
			});
			$(this.parentClass + '__content').each(function () {
				const id = $(this).data('id');
				$(this).attr('id', id);
			});

			const hash = window.location.hash;

			if (hash) {
				const id = hash.substring(1);

				setTimeout(function () {
					$(this.parentClass + '__menu li span').each(function () {
						$(this).toggleClass('active', $(this).attr('id') === id);
					});

					$(this.parentClass + '__content').each(function () {
						$(this).css('display', $(this).attr('id') === id ? 'block' : 'none');
					});

					const $tabsSection = $(this.parentClass);
					if ($tabsSection.length) {
						$('html, body').animate(
							{
								scrollTop: $tabsSection.offset().top - 90
							},
							800
						);
					}
				}, 400);
			}
		});

		$('.mobile-filter').on('click', function (e) {
			e.preventDefault();
			$('.event-archive__filter-cat, .event-list__filters').slideToggle();
		});

		const breakpoint = 767;
		$(window).on('resize', function () {
			if ($(window).width() > breakpoint) {
				$('.event-archive__filter-cat, .event-list__filters').removeAttr('style');
			}
		});

		$('body').on('click', this.tab, function (e) {
			const anchor = $(this).attr('class').replace(/^#/, '');
			$('.' + anchor)
				.css('display', 'block')
				.siblings()
				.css('display', 'none');
			$(this).addClass('active').parent().siblings().find('span').removeClass('active');
			e.preventDefault();
		});
	}
}
